import { Flex, Text, Title } from '@mantine/core';
import cn from 'classnames';
import React from 'react';

import { useDevices } from '@/utils/devices';

import s from './EmptyStub.module.scss';

type EmptyStubProps = {
  title: string;
  description?: React.ReactNode;
  picture?: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
};

const EmptyStub: React.FC<EmptyStubProps> = ({ title, description, className, picture, action }) => {
  const { isCompactViewport } = useDevices();

  return (
    <Flex justify="center" align="center" direction="column" className={cn(s.root, className)}>
      <Flex className={s.root__content} direction="column" gap="xs">
        {picture && (
          <Flex justify="center" align="center">
            {picture}
          </Flex>
        )}
        <Title size={isCompactViewport ? 'h3' : 'h1'} fw={700}>
          {title}
        </Title>
        {description && (
          <Text size={isCompactViewport ? 'sm' : 'md'} className={s.root__description}>
            {description}
          </Text>
        )}
        {action && <Flex className={s.root__action}>{action}</Flex>}
      </Flex>
    </Flex>
  );
};

export default EmptyStub;
